import React, { useEffect, useState } from 'react'
import { LoadingSpinner } from '@CommonComponents';

/**
 * Load an svg asynchronously, displaying a loading spinner while it is fetching
 * and an error if it fails. Since this does not sanitize the svg, it should only be used for
 * our own svgs, not user-uploaded svgs or third-party svgs
 *
 * @param src the path to the svg to load
 * @param props the remaining properties are passed to the div surrounding the loaded svg
 */
export const AsyncSvg = ({src, ...props}) => {
  const [svgContent, setSvgContent] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    const loadSvg = async () => {
      try {
        setLoading(true)
        setError(null)

        const response = await fetch(src)

        if (!response.ok) {
          throw new Error(`Content Failed to Load: ${response.statusText}`)
        }

        const text = await response.text()
        setSvgContent(text)
      } catch (err) {
        setError(err.message)
      } finally {
        setLoading(false)
      }
    }

    if (src) {
      loadSvg()
    }
  }, [src])

  if (loading) {
    return (
      <LoadingSpinner />
    )
  }

  if (error) {
    return (
      <div>
        <p>{error}</p>
      </div>
    )
  }

  return (
    <div
      {...props}
      dangerouslySetInnerHTML={{ __html: svgContent }}
    />
  )
}
